// extracted by mini-css-extract-plugin
export var halfWidth = "Outcomes-module--halfWidth--2c202";
export var outcome = "Outcomes-module--outcome--44518";
export var outcomes = "Outcomes-module--outcomes--7a154";
export var outright = "Outcomes-module--outright--7308b";
export var outrightOutcome = "Outcomes-module--outrightOutcome--7d26a";